
import locale from 'element-ui/lib/locale/lang/en';

export default {
  message: 'hello i18n !!',
  webm: '/en.webm',
  mpfour: '/en.mp4',
  // header
  home: 'Home',
  products: 'Products',
  machining: 'Machining',
  about: 'About',
  news: 'News',
  contact: 'Contact',
  chooseLanguage: 'English',
  home_page: {
    // tslint:disable-next-line:max-line-length
    company_detail: 'In December 2000, some friends decided, more or less on a whim, to set up a company specializing in the production of expanded polytetrafluoroethylene (ePTFE) microporous membrane, and then gave the product a trademark named "DENTIK".',
    product_detail: 'Expanded polytetrafluoroethylene micro (ePTEFE) pore film and extension product solution solver',
    enterpeise_vedio: 'ENTERPEISE VIDEO',
    know_more_slogan: 'Focus on PTFE film development and application of various industries, 20 years as a day.',
    lamination_tech: 'Lamination tech',
    lamination_tech_desc1: 'High-end bonding materials,',
    lamination_tech_desc2: 'Make all kinds of fabrics outstanding, as you wish.',
    exhibition_infos: 'Exhibition infos',
    report_inofs: 'Report infos',
    data_infos: 'Data infos',
    read_more: 'Read More',
    sewing_tech: 'Sewing Technology',
  },
  contact_page: {
    contact: 'CONTACT US',
    // address: '88 Gubei Road, Simen Town, Yuyao City, Zhejiang Province, China',
    contact2: '<a href="mailto:jane@dentik.com">jane@dentik.com</a><br><a href="mailto:cassy@dentik.com">cassy@dentik.com</a>',
    OnlineInquiry:'Online Inquiry',
    form:{
      theme:'theme',
      content:'content',
      CompanyType:{
        title:'CompanyType',
        type:['company','Individual operation']
      },
      CorporateName:'CorporateName',
      name:'name',
      email:'email',
      tel:'tel',
      website: 'website',
    },
    formRules:{
      theme:'Please enter the topic',
      content:'Please enter the content',
      CompanyType:'Please choose the company type',
      CorporateName:'Please enter the name of the company',
      name:'Please enter your name',
      email:'Please enter your mailbox',
      tel:'Please enter the telephone number'
    },
    success:'Submit successfully'
  },
  know_more: 'Know More',
  see_more: 'See More',
  check_more: 'Check all the product list and solution',
  online_customer_service: 'Online Customer',
  online_chat: 'Online chat',
  hot_line: 'Hot line',
  scan_me: 'Scan Me',
  foot: {
    company: 'Ningbo Dengyue New Material Technology Co.,LTD',
    tel: '0574-62160116',
    address: '88 Gubei Road, Simen Town, Yuyao City,<br> Zhejiang Province, China',
    products: [
      {
        id: '42',
        title: 'ePTFE membrane for use in clothing',
      },
      {
        id: '43',
        title: 'Precise filtration ePTFE membrane',
      },
      {
        id: '44',
        title: 'Breathable ePTFE membrane for electronics',
      },
      {
        id: '45',
        title: 'Medical electret ePTFE membrane',
      },
      {
        id: '46',
        title: 'Fabric for outdoor sports',
      },
      {
        id: '47',
        title: 'Flame retardant fabric for use in protective clothing',
      },
    ],
    machining: ['Laminating technology', 'Sewing technology'],
    about: ['Company profile', 'Qualification honor', 'intellectual property right', 'Brand cooperation'],
    news: ['Exhibition', 'Test Report', 'Related articles'],
    webbuilding: 'Design In By：SUNSEMWEB',
  },
  // element-ui
  ...locale,
};
